export default function MTDBar({ dose, doseUnit, fillPercent, styleClass }){
    return <div className="mtd-bar-container">
        <div className="mtd-bar-background"><div className={styleClass + " mtd-bar-foreground"} style={{width: fillPercent}}></div></div>
        <div className="mtd-bar-label">{dose.toFixed(1)} {doseUnit}</div>
    </div>
}